












































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, ref } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartContainer from '@/components/charts/ChartContainer.vue';
import ChartWalkingFootProgressionAngle from '@/components/charts/walking/ChartWalkingFootProgressionAngle.vue';
import ChartStandardSlider from '@/components/charts/standard/ChartStandardSlider.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartWalkingContainerFootProgressionAngle',
  components: {
    ChartWalkingFootProgressionAngle,
    ChartStandardSlider,
    ChartContainer
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    },
    simple: {
      type: Boolean
    }
  },
  setup(properties) {
    const valid = computed(
      () => properties.displayMetrics.aggregates.walking_foot_progression_angle_flat_foot
    );

    const relative = ref(false);
    const advanced = ref(false);

    const normsType = computed(() => {
      return {
        base: [
          properties.norms.walking_foot_progression_angle_flat_foot.bounds.neutral.min,
          properties.norms.walking_foot_progression_angle_flat_foot.bounds.neutral.max
        ]
      };
    });

    return {
      // Valid
      valid,
      // Values
      relative,
      advanced,
      normsType
    };
  }
});
